// extracted by mini-css-extract-plugin
export default {"banner-info-container":"banner-info-container--mp-gF4eV","bannerInfoContainer":"banner-info-container--mp-gF4eV","labelText":"labelText--mp-kFZ59","infoText":"infoText--mp-Yb1Uk"};